module.exports = __webpack_public_path__ + "static/media/1008159.db752f0e.png";